document.addEventListener('DOMContentLoaded', function () {

  let items = document.querySelectorAll(".mega-menu")
  let currentItemIndex

  items.forEach((item, itemIndex) => {

    const content = item.querySelector(".mega-menu__content")

    item.addEventListener("mouseover", () => {
      if (
        (currentItemIndex === 0 && currentItemIndex !== itemIndex) ||
        (currentItemIndex && currentItemIndex !== itemIndex)
      ) {
        items[currentItemIndex].removeAttribute("open")
      }

      currentItemIndex = itemIndex
      item.setAttribute("open", true)
    })

    item.addEventListener("mouseleave", () => {
      let close = true
      content.addEventListener("mouseover", () => {
        close = false
      })

      setTimeout(function () {
        if (close) {
          item.removeAttribute("open")
        }
      }, 100);
    })

    content.addEventListener("mouseleave", () => {
      item.removeAttribute("open")
    })
  })
}, false);